import { z } from 'zod';

export const ClubHostPublicSchema = z.object({
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  fullName: z.string().nullable(),
  shortName: z.string().nullable(),
  subtitle: z.string().nullable(),
  description: z.string().nullable(),
  avatarUrl: z.string().nullable(),
});

export type ClubHostPublic = z.infer<typeof ClubHostPublicSchema>;

export const AdminClubHostSchema = ClubHostPublicSchema.extend({
  id: z.string().nullable().optional(),
  avatarAssetId: z.string().nullable(),
});

export type AdminClubHost = z.infer<typeof AdminClubHostSchema>;
